import React, { FunctionComponent, useEffect, useState } from 'react';
import { Presentation } from './presentation';
import { RelatedRecruitmentsListProps as Props, RelatedRecruitmentsListState } from './types';
import { getRelatedRecruitments } from '../../../services/events';

export const Component: FunctionComponent<Props> = (props) => {
  const { eventId } = props;
  const [state, setState] = useState<RelatedRecruitmentsListState>({
    recruitments: [],
  });

  useEffect(() => {
    const fetchRecruitments = async () => {
      try {
        const data = await getRelatedRecruitments(eventId);
        setState(prev => ({
          ...prev,
          recruitments: data.recruitments,
        }));
      } catch (error) {
        console.error('関連求人の取得に失敗しました', error);
      }
    };

    fetchRecruitments();
  }, [eventId]);

  return <Presentation state={state} />;
};
